export default {
  cards: {
    chart: {
      sumberPendanaan: {
        queryName: "sumber_pendanaan",
        content: {
          title: "Sumber pendanaan",
          showTitle: false,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik sumber pendanaan",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 500,
          },
          chartOption: {
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Sumber Biaya",
              dataIndex: "sumber_biaya",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      kondisiTempatIbadah: {
        queryName: "kondisi_tempat_ibadah",
        content: {
          title: "Kondisi Tempat Ibadah",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik kondisi tempat ibadah",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return value.split(" ").join("\n");
                },
              },
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Kondisi Sarana Tempat Ibadah",
              dataIndex: "sarana_tempatibadah",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      kondisiRuangIbadah: {
        queryName: "kondisi_ruang_ibadah",
        content: {
          title: "Kondisi Ruang Ibadah",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik kondisi ruang ibadah",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return value.split(" ").join("\n");
                },
              },
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Kondisi Sarana Ruang Ibadah",
              dataIndex: "sarana_ruangibadah",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      kondisiPerpustakaan: {
        queryName: "kondisi_perpustakaan",
        content: {
          title: "Kondisi Perpustakaan",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik kondisi perpustakaan",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return value.split(" ").join("\n");
                },
              },
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Kondisi Sarana Perpustakaan",
              dataIndex: "sarana_perpustakaan",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      kelengkapanBuku: {
        queryName: "kelengkapan_buku_perpustakaan",
        content: {
          title: "Kelengkapan Buku di Perpustakaan",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik kelengkapan buku di perpustakaan",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
          },
          chartOption: {
            grid: {
              bottom: 40,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return value.split(" ").join("\n");
                },
              },
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Kelengkapan Buku di Perpustakaan",
              dataIndex: "sarana_buku",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      jumlahBuku: {
        queryName: "jumlah_buku_perpustakaan",
        content: {
          title: "Jumlah Buku di Perpustakaan",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik jumlah buku di perpustakaan",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
            backgroundColor: "#389BF6",
            titleColor: "white",
          },
          chartOption: {
            textStyle: {
              color: "white",
            },
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "white",
                },
              },
            ],
          },
          columns: [
            {
              title: "Jumlah Buku di Perpustakaan",
              dataIndex: "val",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
    },
  },
};
